export const LeadModuleId = 1;
export const AccountModuleId = 2;
export const CaseModuleId = 8;
export const TaskModuleId = 21;
export const PhoneNumberFormatModuleId = 100;
export const OpportunityModuleId = 3;
export const ContactModuleId = 40;
export const TerritoryModuleId = 5;
export const ProductModuleId = 79;
export const ActivityModuleId = 324;
export const InvoiceOrderModuleId = 10000004;
export const CMOrderModuleId = 10000005;
export const EstimateOrderModuleId = 244;
export const SOModuleId = 245;
export const OrderModuleId = 246;
export const PurchaseOrderModuleId = 251;
export const CustomerRMAModuleId = 10000055;
export const BillOrderModuleId = 10000038;
export const BillPaymentModuleId = 10000007;
export const VendorReturnModuleId = 10000082;
export const VendorCreditModuleId = 10000130;
export const VendorModuleId = 99;
export const LocationModuleId = 248;
export const categoryModuleId = 21;
export const categorychannelId = 1;
export const exportChannelId = 0;
export const exportModuleId = 21;
export const workspaceModuleId = 355;
export const JournalModuleId = 10000122;
export const ReconciliationReportModuleId = 10000150;
export const ReportModuleId = 10000050;
export const TrialBalanceModuleId = 10000128;
export const GeneralLedgerModuleId = 10000130;
export const LocationModuleName = "Location";
export const VendorModuleName = "Vendor";
export const AccountModuleName = "Account";
export const ContactModuleName = "Contact";
export const LeadModuleName = "Lead";
export const OpportunityModuleName = "Opportunity";
export const ProductModuleName = 'Product';
export const CaseModuleName = 'Cases';
export const BillOrderModuleName = 'GSBillOrder';
export const CustomerRmaModuleName = 'GSCustomerRMA';
export const EstimateModuleName = 'GSEstimate';
export const InvoiceModuleName = 'GSInvoice';
export const PurchaseOrderModuleName = 'GSPurchaseOrder';
export const TerritoryModuleName = 'GSTerritory';
export const SalesOrderModuleName = 'GSSalesOrder';
export const SerialNoModuleName = 'SerialNo';
export const CreditMemo = 'GSCreditMemo';
export const workspaceModuleName = 'Workspaces';


// export const ModuleName = 'Product'


